// ⚠️ AUTO-GENERATED — DO NOT EDIT MANUALLY
// Source: ./svg/IconFileZip.svg — regenerate with `nx run creditflowresearch-uilib:icons-generate --write`
import BaseIcon from './BaseIcon';
import type { IIconProps } from './types';

const IconFileZip = (props: IIconProps) => (
  <BaseIcon viewBox="0 0 16 16" fill="currentColor" { ...props }>
    <path fillRule="evenodd" clipRule="evenodd" d="M3.6 0H10L14.8 4.8V7H2V1.6C2 0.72 2.72 0 3.6 0ZM9.2 5.6H13.6L9.2 1.2V5.6Z" />
    <path d="M10.9305 12.0117H11.8289C12.0946 12.0117 12.2964 11.9453 12.4344 11.8125C12.575 11.6797 12.6453 11.4922 12.6453 11.25C12.6453 10.9844 12.5737 10.7721 12.4305 10.6133C12.2873 10.4544 12.0919 10.3737 11.8446 10.3711H10.9305V12.0117Z" />
    <path fillRule="evenodd" clipRule="evenodd" d="M0 8H16V16H0V8ZM6.84033 13.9453H4.12158L6.81299 10.0156V9.3125H2.39502V10.3711H5.12158L2.41064 14.2773V15H6.84033V13.9453ZM7.39908 15H8.76627V9.3125H7.39908V15ZM10.9305 13.0703V15H9.55939V9.3125H11.8289C12.2638 9.3125 12.6479 9.39323 12.9813 9.55469C13.3172 9.71354 13.5763 9.94141 13.7586 10.2383C13.9435 10.5326 14.036 10.8672 14.036 11.2422C14.036 11.7969 13.8367 12.2409 13.4383 12.5742C13.0425 12.9049 12.4982 13.0703 11.8055 13.0703H10.9305Z" />
  </BaseIcon>
);

export default IconFileZip;
